import React from 'react'
import { useLocation, useNavigate } from 'react-router-dom'
import { useAuth } from '../../context/AuthContext'
import { WARIANTY_PODGLADU } from '../../lib/plany'

/**
 * Plakietka podglądu planów (FE-01), tylko na adresie lokalnym i tylko, gdy podgląd jest włączony (`?plan=free`).
 * Przypomina, że plan na ekranie jest udawany, i pozwala przełączyć wariant bez pisania adresu.
 * Działa na zalogowanym koncie: niezalogowany widzi stan „bez konta” bez żadnego podglądu.
 */
const PodgladPlanu = () => {
  const { podgladPlanu, isAuthenticated } = useAuth()
  const location = useLocation()
  const navigate = useNavigate()
  if (!podgladPlanu) return null

  const przelacz = (wariant) => {
    const par = new URLSearchParams(location.search)
    par.set('plan', wariant)
    navigate({ pathname: location.pathname, search: `?${par.toString()}` }, { replace: true })
  }

  return (
    <div className="fixed bottom-3 left-1/2 z-[60] -translate-x-1/2 rounded-full border border-amber-300 bg-amber-50
                    px-3 py-1.5 text-xs text-amber-900 shadow-lg dark:border-amber-700 dark:bg-amber-950 dark:text-amber-100">
      <label className="flex items-center gap-2">
        <span className="font-semibold">Podgląd planu (localhost):</span>
        <select
          value={podgladPlanu}
          onChange={(e) => przelacz(e.target.value)}
          className="rounded border border-amber-300 bg-white px-1 py-0.5 text-xs dark:bg-amber-900"
        >
          {Object.entries(WARIANTY_PODGLADU).map(([klucz, { etykieta }]) => (
            <option key={klucz} value={klucz}>{etykieta}</option>
          ))}
          <option value="wyczysc">wyłącz podgląd</option>
        </select>
        {!isAuthenticated && <span>zaloguj się, żeby zobaczyć wariant</span>}
      </label>
    </div>
  )
}

export default PodgladPlanu
